import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import {
    asyncGetParam,
    asyncGetSubmotive1Historical,
} from '../../../../../services/param.service';
import { Param, ParamHistorical } from '../../../../../shared/types/param';
import { SUBMOTIVE1 } from '../../../../../routes/paths';

export const useSubmotive1Detail = () => {
    const [showHistorical, setShowHistorical] = useState(false);
    const navigate = useNavigate();
    const { idSubmotive1 } = useParams();
    const [loading, setLoading] = useState(false);
    const [submotive1, setSubmotive1] = useState<Param>();
    const [submotive1Historical, setSubmotive1Historical] =
        useState<ParamHistorical[]>();

    useEffect(() => {
        if (Boolean(idSubmotive1)) {
            setLoading(true);
            asyncGetParam(idSubmotive1)
                .then((submotive1: any) => {
                    if (!submotive1 || !submotive1.items) navigate(SUBMOTIVE1);
                    setSubmotive1(submotive1?.items);
                })
                .finally(() => setLoading(false));
        }
    }, [idSubmotive1]);

    useEffect(() => {
        if (showHistorical) {
            setLoading(true);
            asyncGetSubmotive1Historical(idSubmotive1)
                .then((resp) => {
                    if (resp) setSubmotive1Historical(resp);
                })
                .finally(() => setLoading(false));
        }
    }, [showHistorical]);

    return {
        loading,
        submotive1,
        submotive1Historical,
        showHistorical,
        setShowHistorical,
    };
};
